import PdfViewer from '@/shared/components/PDF';
import {Box} from '@mui/material';
import {PrintableService} from '@/utils/services/organization-printables';
import {useEffect, useRef, useState} from 'react';
import {useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector} from '@/store/organization-event';
import Loader from '@/shared/components/Loader';
import {formContentStyle} from '@/components/Organization/Dashboard/CreateNewEvent/EventSetting/FormContent/FormContent.styles';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';

const QRCode = () => {
	const baseURL = process.env.REACT_APP_FE_URL;

	const currentEvent = useAppSelector(getCurrentEventSelector);
	const [pdfData, setPdfData] = useState<string>('');
	const [isLoading, setIsLoading] = useState(false);
	const objectUrlRef = useRef<string>('');

	useEffect(() => {
		if (!currentEvent) return;

		setIsLoading(true);

		PrintableService.getQRCode(`${baseURL}/${currentEvent.customizeWebpage}`)
			.then(({data}) => {
				if (objectUrlRef.current) {
					URL.revokeObjectURL(objectUrlRef.current);
				}
				const blob = new Blob([data], {type: 'application/pdf'});
				objectUrlRef.current = URL.createObjectURL(blob);
				setPdfData(objectUrlRef.current);
			})
			.catch((error) => {
				toast.error(getErrorMessage(error));
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [currentEvent?.id]);

	useEffect(() => {
		return () => {
			if (objectUrlRef.current) {
				URL.revokeObjectURL(objectUrlRef.current);
			}
		};
	}, []);

	return (
		<Box>
			{isLoading ? (
				<Box sx={{height: 'calc(100vh - 270px)'}}>
					<Loader sx={formContentStyle.loader} size={50} />
				</Box>
			) : pdfData ? (
				<PdfViewer fileUrl={pdfData} isQR />
			) : null}
		</Box>
	);
};

export default QRCode;
